// src/components/session/SampleCityBand.js
// A one-time offer, right after onboarding: try the tool with a sample city first.
// Shown as a quiet band (not a dialog). Once used or dismissed it does not come back.
// TODO(K8): approve wording.
import React, { useState } from "react";
import { Alert, Button, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationCityIcon from "@mui/icons-material/LocationCity";

const KEY = "t4r_sample_offer_done";

function wasDone() {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export default function SampleCityBand({ onTry }) {
  const [done, setDone] = useState(wasDone);
  if (done) return null;
  const finish = () => {
    setDone(true);
    try {
      window.localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
  };
  return (
    <Alert
      severity="info"
      icon={<LocationCityIcon />}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <Button color="inherit" size="small" variant="outlined" onClick={() => { finish(); onTry(); }} sx={{ textTransform: "none" }}>
            Try with a sample city
          </Button>
          <IconButton aria-label="No thanks" title="No thanks" color="inherit" size="small" onClick={finish}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      }
    >
      New here? See how the tool works with a sample city first. You can replace every answer with your own.
    </Alert>
  );
}
